import React, { useContext, useState } from 'react';

import { cancelarDemanda, cancelarOCDemanda } from '@app/api/demanda';
import { Button, FormatText, FormInput, FormSubmitButton, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal, Tooltip } from 'antd';

import QuestionarioContextProvider from '../../../../hooks/useQuestionario';
import { Visibility } from '@app/components';

interface Props {
  label?: string;
  setUpdate: React.Dispatch<React.SetStateAction<boolean>>;
  update: boolean;
  cancelarOcDemanda?: boolean;
}

function ModalEliminarDemanda({
  update,
  setUpdate,
  label = 'Eliminar',
  cancelarOcDemanda = false
}: Props) {

  const [exibirModal, setExibirModal] = useState(false);
  const { demandaData } = useContext(QuestionarioContextProvider);

  const handleSubmit = (values: any) => {
    if (demandaData) {
      values.demandaId = demandaData.id;

      if (cancelarOcDemanda) {
        cancelarOCDemanda(demandaData.id, values.justificativaCancelamento).then((data: any) => {
          if (data && data.valid) {
            setUpdate(!update);
            setExibirModal(false);
          }
        });
      } else {
        cancelarDemanda(values.demandaId, values).then((data: any) => {
          if (data && data.valid) {
            setUpdate(!update);
            setExibirModal(false);
          }
        });
      }
    }
  };

  return (
    <>

      <Tooltip title={`${label} a demanda`}>
        <Button
          id="mrn-button-eliminar-demanda"
          type="danger"
          onClick={() => {
            setExibirModal(true);
          }}>
          {label}
        </Button>
      </Tooltip>
      <Visibility
        visible={exibirModal}
      >
        <Modal
          title="Eliminar Demanda"
          width="1200px"
          visible={exibirModal}
          onCancel={() => {
            setExibirModal(false);
          }}
          footer={null}>
          <MasterDetailForm
            key="formTemplate"
            onSubmit={handleSubmit}
            actions={[
              <Button
                id="mrn-button-eliminar-demanda-modal-fechar"
                type="link"
                onClick={() => {
                  setExibirModal(false);
                }}
                key="close">
                Fechar
              </Button>,
              <FormSubmitButton
                id="mrn-button-eliminar-demanda-modal-enviar"
                noIcon type="primary" key="save">
                <FormatText id="ui.commons.save" uppercase />
              </FormSubmitButton>,
            ]}>
            <Widget>
              <Row>
                <FormInput name="justificativaCancelamento" label="Justificativa de Cancelamento" span={12} required />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Modal>
      </Visibility>
    </>
  );
}

export default ModalEliminarDemanda;
